export default {
	clientTypes: {
		corporate: {
			id: "corporate",
			value: "Corporate"
		},
		personal: {
			id: "personal",
			value: "Personal"
		},
		trust: {
			id: "trust",
			value: "Trusts"
		}
	},
	managedByRoles: {
		seniorManager: "senior_manager",
		manager: "manager",
		bookkeeperManager: "bookkeeper_manager"
	},
	statuses: [
		{
			key: "active",
			value: "Active"
		},
		{
			key: "inactive",
			value: "Inactive"
		},
		{
			key: "dissolved",
			value: "Dissolved"
		},
		{
			key: "soft_deleted",
			value: "Deleted"
		},
		{
			key: "all",
			value: "All"
		}
	],
	contactOrderQueries: {
		firstName: "first_name",
		lastName: "last_name",
		email: "email",
		phone: "phone",
		dob: "dob",
		sin: "sin"
	},
	customFieldTypes: {
		string: "string",
		boolean: "boolean",
		number: "number",
		list: "list"
	}
};
